import React from "react";

import { PickerField } from "@/components/selection/PickerField";
import { WheelInputField } from "@/components/selection/WheelInputField";
import { RegistrationActions } from "@/layouts/RegistrationFlowLayout";

type AssetStepProps = {
  financialAssetRange: string;
  holdingPropertyCount: string;
  onChangeFinancialAssetRange: (value: string) => void;
  onChangeHoldingPropertyCount: (value: string) => void;
  loanRangeOptions: { value: string; label: string }[];
  showPropertyOwnershipFields: boolean;
  errors: { asset?: string; count?: string };
  onBlur: (name: string) => void;
  onNext: () => void;
  last: boolean;
  onBack: () => void;
};
const AssetStep: React.FC<AssetStepProps> = ({
  financialAssetRange,
  holdingPropertyCount,
  onChangeFinancialAssetRange,
  onChangeHoldingPropertyCount,
  loanRangeOptions,
  showPropertyOwnershipFields,
  errors,
  onBlur,
  onNext,
  last,
  onBack,
}) => (
  <>
    <PickerField
      label="金融資産（預金・株式など）"
      value={financialAssetRange}
      onChange={(value) => onChangeFinancialAssetRange(String(value))}
      options={loanRangeOptions}
      error={errors.asset}
      onBlur={() => onBlur("asset")}
    />
    {showPropertyOwnershipFields && (
      <WheelInputField
        label="投資用不動産の保有数"
        value={holdingPropertyCount}
        onChange={onChangeHoldingPropertyCount}
        error={errors.count}
        onBlur={() => onBlur("count")}
      />
    )}
    <RegistrationActions onNext={onNext} onBack={onBack} label={last ? "診断する" : "次へ"} />
  </>
);
export default AssetStep;
